import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

const effectiveDateV1Schema = z.iso.date()

export const workerStatusV1Schema = z.enum(["Active", "Inactive"])
export const workerRelationshipKindV1Schema = z.enum([
  "Employment",
  "Contractor Engagement",
])
export const relationshipChangeDecisionV1Schema = z.enum(["approve", "reject"])

export const workerCreateV1Schema = z.object({
  workerId: entityIdSchema,
  identityId: entityIdSchema.nullable(),
  displayName: z.string().trim().min(1).max(160),
}).strict()

export const relationshipChangeRequestV1Schema = z.object({
  changeRequestId: entityIdSchema,
  workerId: entityIdSchema,
  proposedRelationshipId: entityIdSchema,
  relationshipKind: workerRelationshipKindV1Schema,
  effectiveFrom: effectiveDateV1Schema,
  effectiveTo: effectiveDateV1Schema.nullable(),
  replacesRelationshipId: entityIdSchema.nullable(),
  reason: z.string().trim().min(1).max(2_000),
}).strict().superRefine((value, context) => {
  if (value.effectiveTo !== null && value.effectiveTo < value.effectiveFrom) {
    context.addIssue({
      code: "custom",
      path: ["effectiveTo"],
      message: "Effective end must not precede effective start.",
    })
  }
  if (value.proposedRelationshipId === value.replacesRelationshipId) {
    context.addIssue({
      code: "custom",
      path: ["proposedRelationshipId"],
      message: "Proposed and replaced relationships must differ.",
    })
  }
})

export const relationshipChangeReviewV1Schema = z.object({
  decision: relationshipChangeDecisionV1Schema,
  reason: z.string().trim().min(1).max(2_000),
}).strict()

export const workerRelationshipResultV1Schema = z.object({
  entityType: z.enum(["worker", "relationship_change"]),
  entityId: entityIdSchema,
  state: z.string().min(1).max(80),
  version: z.number().int().nonnegative(),
  workerId: entityIdSchema,
  legalEntityId: entityIdSchema.nullable(),
  relationshipId: entityIdSchema.nullable(),
  relationshipKind: workerRelationshipKindV1Schema.nullable(),
}).strict()

export type WorkerCreateV1 = z.infer<typeof workerCreateV1Schema>
export type RelationshipChangeRequestV1 = z.infer<
  typeof relationshipChangeRequestV1Schema
>
export type RelationshipChangeReviewV1 = z.infer<
  typeof relationshipChangeReviewV1Schema
>
export type WorkerRelationshipResultV1 = z.infer<
  typeof workerRelationshipResultV1Schema
>
